export default "__VITE_ASSET__D_Q7F7k1__"